import get from "lodash/get";
import type { Action } from "../../actions/types";
import { getSharedProductFromUrl } from "../../utils/url";

export type StoreState = {
  [key: string]: any;
};

// A product-share widget is told its product through the iframe hash, and this
// is what puts it where Text and Image interpolate from.
const sharedProduct = getSharedProductFromUrl();

export const initialState: StoreState = sharedProduct
  ? { product: sharedProduct }
  : {};

export function reducer(state: StoreState = initialState, action: Action) {
  if (action.type === "CORS_REQUEST") {
    let customer;

    switch (get(action, "payload.type") || get(action, "fullPayload.type")) {
      case "purchase":
        customer = {
          ...state.customer,
          ...action.fullPayload.customer,
        };

        return {
          ...state,
          purchase: action.fullPayload,
          customer,
        };

      case "product":
        return {
          ...state,
          product: action.fullPayload,
        };

      case "email":
      case "email_capture":
      case "sign_up":
        customer = state.customer || {};

        return {
          ...state,
          customer: { ...customer, ...action.fullPayload },
        };

      case "page":
        return {
          ...state,
          page: action.fullPayload,
        };

      case "customer":
        return {
          ...state,
          customer: action.fullPayload,
        };

      default:
        return state;
    }
  }

  return state;
}
